import React, { useContext } from 'react';
import "../../../ui-styles/list/PastAppointmentDetails.css";
import "../../../ui-styles/sliders/RightChildSlider.css";
import "../../../ui-styles/filterList/filterInput.css";

import { LangCtx } from "../../../lib/context";
import { dateFormat, timeFormat } from '../../../lib/functions';



//const filterList = [{ value: "lastVisit", label: "Last Visit" }, { value: "Last Week", label: "Last Week" }, { value: "Last Month", label: "Last Month" }, { value: "Last Year", label: "Last Year" }, { value: "All", label: "All" },]

const PatientPastAppointmentItem = (props) => {
    const { l } = useContext(LangCtx);

    return (
        <div className="padtlsItem">
            <small className="timeTxt">
                <img src="/images/icons/time-outline.png" alt="icon" className="invertGray" />
                {`${dateFormat(props.data.startTime)} ${timeFormat(props.data.startTime)} - ${timeFormat(props.data.endTime)}`}
                     </small>
            <span className="forTxt">{l.appt_for}<small>{l[props.data.reason]}</small></span>
            <p className="paraTxt">{l.appt_summary} <span>{l[props.data.descripton]}</span></p>
            <div className="padtlsAction">
                {props?.data?.prescription_status && <div className="padtlsIconBox" onClick={() => props.handlePscpnSlide(props.data)}>
                    <img src="/images/icons/prescription-outline.png" alt="icon" className='invertPrimary'/>
                    <span>{l.presc}</span>
                </div>}
                <div className="padtlsIconBox" onClick={props.handleReports}>
                    <img src="/images/icons/medical-reports-outline.png" alt="icon" className='invertPrimary'/>
                    <span>{l.reports}</span>
                </div>
            </div>
        </div>
    )
}
export default PatientPastAppointmentItem;
